import { ClientBrandConfig } from 'types/brand-config';

export function createMailToSupportHref(
  brand: ClientBrandConfig,
  subject?: string
) {
  return `mailTo:${brand.email}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}`;
}
